import { createSecretPathRedactor, REDACTED_VALUE } from '@lite-workspace/secret-paths';

// Страницы fotoclass и photobook, где секрет — сегмент адреса; бэк этих путей не видит, поэтому их нет в общем списке.
export const PAGE_SECRET_PATH_PREFIXES: readonly string[] = [
  '/client/t/',
  '/client/',
  '/clients/',
  '/books/uid/',
  '/book/uid/',
  '/forms/',
  '/prints/',
];

// Короче — буквальная замена задела бы посторонний текст.
const MIN_PAGE_SECRET_LENGTH = 8;

let redactPagePaths: ((text: string) => string) | undefined;

// Лениво: в Safari до 16.4 lookbehind шаблона бросает, и пусть бросает при отправке события, а не при импорте.
export function redactSecretPaths(text: string): string {
  redactPagePaths ??= createSecretPathRedactor(PAGE_SECRET_PATH_PREFIXES);

  return redactPagePaths(text);
}

// Секрет страницы встречается и без префикса: роутер пишет путь без «/» (NG04002), книга клиента зовёт /api/books/<токен>.
export function currentPageSecrets(): string[] {
  const path: string | undefined = globalThis.location?.pathname;
  if (!path) {
    return [];
  }

  // Сегменты как у роутера: без «;…» и раскодированы один раз — /%63lient/ и /client;x=1/ ведут на /client/.
  const rawSegments: string[] = path.split('/').map(segment => segment.split(';')[0]);
  const routedSegments: string[] = rawSegments.map(safeDecodeURIComponent);
  // Самый длинный: на /client/t/<токен> префикс /client/ дал бы сегмент «t».
  const prefixWords: string[] | undefined = PAGE_SECRET_PATH_PREFIXES.map(prefix => prefix.split('/').slice(0, -1))
    .filter(words => words.every((word, index) => routedSegments[index] === word))
    .sort((a, b) => b.length - a.length)[0];
  if (!prefixWords) {
    return [];
  }

  const rawSegment: string = rawSegments[prefixWords.length] ?? '';
  const segment: string = safeDecodeURIComponent(rawSegment);
  if (segment.length < MIN_PAGE_SECRET_LENGTH || segment.startsWith(':')) {
    return [];
  }

  // pathname уже закодирован, а роутер пишет в текст ошибки раскодированный путь.
  return [...new Set([rawSegment, segment])];
}

function safeDecodeURIComponent(segment: string): string {
  try {
    return decodeURIComponent(segment);
  } catch {
    return segment;
  }
}

export function redactPageSecrets(text: string, pageSecrets: readonly string[]): string {
  return pageSecrets.reduce((result, secret) => result.split(secret).join(REDACTED_VALUE), text);
}
